import React, { useState } from 'react';
import { Linkedin } from 'lucide-react';
import { PrivacyModal } from './PrivacyModal';
import { SalesConditionsModal } from './SalesConditionsModal';
export function Footer() {
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isSalesOpen, setIsSalesOpen] = useState(false);
  return <>
      <PrivacyModal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} data-id="element-84" />
      <SalesConditionsModal isOpen={isSalesOpen} onClose={() => setIsSalesOpen(false)} data-id="element-85" />
      <footer className="bg-zumpago-red text-white pt-16 pb-8" data-id="element-86">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-87">
          <div className="flex flex-col md:flex-row items-center justify-between gap-8 mb-12" data-id="element-88">
            <div className="flex flex-col items-center md:items-start" data-id="element-89">
              <a href="#inicio" className="inline-block mb-6 bg-white rounded-xl px-4 py-2" data-id="element-90">
                <img src="https://cdn.magicpatterns.com/uploads/uaZfLQJvdRAZ5JSimEabuc/zumpago.png" alt="Zumpago" className="h-10 w-auto" data-id="element-91" />
              </a>
              <p className="text-red-100 text-sm leading-relaxed max-w-md text-center md:text-left" data-id="element-92">
                Transformando el ecosistema de pagos en América Latina con
                tecnología segura, rápida y confiable.
              </p>
            </div>
            <div className="flex gap-4" data-id="element-93">
              <a href="https://www.linkedin.com/company/zumpago/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors" data-id="element-94">
                <Linkedin className="w-5 h-5" data-id="element-95" />
              </a>
            </div>
          </div>

          <div className="border-t border-red-500/50 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-96">
            <p className="text-red-100 text-sm" data-id="element-97">
              Copyright © {new Date().getFullYear()} ZUMPAGO SPA. Todos los
              derechos reservados.
            </p>
            <div className="flex gap-6 text-sm" data-id="element-98">
              <button onClick={() => setIsPrivacyOpen(true)} className="text-red-100 hover:text-white transition-colors" data-id="element-99">
                Políticas de Privacidad
              </button>
              <button onClick={() => setIsSalesOpen(true)} className="text-red-100 hover:text-white transition-colors" data-id="element-100">
                Términos y Condiciones
              </button>
            </div>
          </div>
        </div>
      </footer>
    </>;
}